<template>
  <el-dialog :title="title" :visible="show" @close="$emit('close')" width="40%">
    <form class="stacked-form" @submit.prevent="addComment">
      <fg-input label="Text">
        <textarea class="form-control" v-model="comment" rows="3"></textarea>
      </fg-input>
      <div class="text-right">
        <button class="btn btn-primary">Hinzufügen</button>
      </div>
    </form>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'

export default {
  components: { [Dialog.name]: Dialog },
  props: ['show', 'title'],
  data () {
    return {
      comment: null
    }
  },
  methods: {
    addComment () {
      this.$emit('addComment', this.comment)
      this.comment = null
      this.$emit('close')
    }
  }
}
</script>

<style>
</style>
